import React from "react";
import ContractorHeader from "./ContractorHeader";
import ContractorAppIcons from "./ContractorAppIcons";

function ContractorDashboard() {
  return (
    <div>
      <ContractorHeader />
      <ContractorAppIcons />
    </div>
  );
}

export default ContractorDashboard;
